module.exports = {
  initials: (fname, lname) =>
    `${fname ? fname.charAt(0).toUpperCase() : ""}${lname ? lname.charAt(0).toUpperCase() : ""}`,
};
